var map = {
	"./1.jpg": 2170,
	"./10.jpg": 2171,
	"./2.jpg": 2172,
	"./3.jpg": 2173,
	"./4.jpg": 2174,
	"./5.jpg": 2175,
	"./6.jpg": 2176,
	"./7.jpg": 2177,
	"./8.jpg": 2178,
	"./9.jpg": 2179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2169;